import React from 'react';
import { Container } from '@si-armes/dsfr-react';
import FormulaireArmePerdueVolee from './components/FormulaireArmePerdueVolee';

const ArmePerdueVolee = () => {
    return (
        <Container>
            <h1>Déclarer arme(s) perdue(s)/volée(s)</h1>
            <FormulaireArmePerdueVolee />
        </Container>
    );
};

export default ArmePerdueVolee;
